import {Controller} from "@hotwired/stimulus";
import JustValidate from "just-validate";


export default class extends Controller {
    connect() {
        this.validator = new JustValidate(this.element, {
            validateBeforeSubmitting: true,
            lockForm: true,
            focusInvalidField: true,
            errorFieldCssClass: 'is-invalid',
        });

        const emailSelector = "#forgot-password-form input[name$='[username]']";

        this.validator
            .addField(emailSelector, [
                {rule: 'required', errorMessage: 'Email address is required'},
                {rule: 'email', errorMessage: 'Please enter a valid email address'},
            ])
            .onSuccess((event) => {
                event.target.submit();
            });
    }

    disconnect() {
        if (this.validator?.destroy) this.validator.destroy();
    }
}